/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Cta_TitleInputs */



/**
* | output |
* | --- |
* | "Not sure which service you need?" |
*
* @param {Services_Cta_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const services_cta_title = /** @type {((inputs?: Services_Cta_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Cta_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("不确定需要哪项服务？")
	return /** @type {LocalizedString} */ ("Not sure which service you need?")
});